import React from 'react';
import { FiMonitor, FiTablet, FiSmartphone, FiX, FiInfo } from 'react-icons/fi';
import './DeviceRecommendationModal.css';

const DeviceRecommendationModal = ({ isOpen, onClose, deviceType }) => {
  if (!isOpen || deviceType !== 'mobile') return null;

  return (
    <div className="device-modal-overlay">
      <div className="device-modal">
        <div className="device-modal-header">
          <div className="device-modal-icon">
            <FiInfo size={24} />
          </div>
          <button className="device-modal-close" onClick={onClose}>
            <FiX size={20} />
          </button>
        </div>

        <div className="device-modal-content">
          <h3>Welcome to Liwaza!</h3>
          <p className="device-modal-description">
            We've detected you're using a mobile device. For the best learning
            experience, we recommend using Liwaza on:
          </p>

          <div className="device-recommendations">
            <div className="device-option">
              <FiMonitor size={32} />
              <span>Desktop Computer</span>
            </div>
            <div className="device-option">
              <FiMonitor size={32} />
              <span>Laptop</span>
            </div>
            <div className="device-option">
              <FiTablet size={32} />
              <span>Tablet</span>
            </div>
          </div>

          <div className="device-modal-benefits">
            <h4>Why these devices work better:</h4>
            <ul>
              <li>Larger screen for better reading and writing practice</li>
              <li>Full keyboard for essay writing and typing exercises</li>
              <li>Better performance for interactive lessons</li>
              <li>Optimal layout for GRE and IELTS practice tests</li>
              <li>Enhanced video interview practice experience</li>
            </ul>
          </div>

          <div className="device-modal-note">
            <FiSmartphone size={16} />
            <span>
              You can still use Liwaza on mobile, but some features may be
              limited. You'll not have access to the full features of GRE/GMAT
              preparation, IELTS preparation, Resumé builder, Essays, Coaching,
              and more.
            </span>
          </div>
        </div>

        <div className="device-modal-actions">
          <button className="btn-lwz-primary" onClick={onClose}>
            Continue Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeviceRecommendationModal;
